import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateOAuthState(): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => chars[byte % chars.length]).join("");
}

export function validateOAuthState(state: string): boolean {
  return /^[0-9A-Za-z_-]{4,512}$/.test(state);
}

export function normalizeUrlForHttps(url?: string): string {
  if (!url) {
    return "";
  }

  try {
    const parsed = new URL(url);
    const hostname = parsed.hostname;
    const isLocalhost =
      hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";
    const isSecureContext =
      typeof window !== "undefined" && window.location?.protocol === "https:";

    if (isSecureContext && parsed.protocol === "http:" && !isLocalhost) {
      parsed.protocol = "https:";
    }

    const normalized = parsed.toString();
    return normalized.endsWith("/") ? normalized.slice(0, -1) : normalized;
  } catch {
    return url;
  }
}
